var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip-icon",style:(_vm.Style)},[(_vm.state==true)?_c('div',[_c('i',{staticClass:"icon el-icon-success"})]):_vm._e(),(_vm.state==false)?_c('div',[_c('i',{staticClass:"icon el-icon-error"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }